// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".content_type_0004:not(.content_type_0004~.content_type_0004){border-top:1px dotted #777!important}.content_type_0004:last-of-type{border-bottom:1px dotted #777!important}", ""]);
// Exports
module.exports = exports;
